// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","415":"component---src-pages-404-jsx","624":"fb7d5399"}[chunkId] || chunkId) + "-" + {"245":"5d8281141db92b0459c9","415":"3b00d88a083d7a61659f","471":"d3d19b073aa5477e1a7b","624":"4ef251c54853bf6299c0","707":"3f84a03d18d0510abfc7"}[chunkId] + ".js";
};